import { Link } from 'react-router-dom';
import { categories } from '@/mocks/siteData';

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="container-site">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            研究专题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            五大专题分类，涵盖《金瓶梅》研究的各个维度
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {categories.map((cat, index) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-8 hover:border-primary-200/60 transition-all duration-300"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-lg mb-4 ${
                cat.color === 'accent' ? 'bg-accent-100 text-accent-600' :
                cat.color === 'primary' ? 'bg-primary-100 text-primary-600' :
                'bg-secondary-100 text-secondary-600'
              }`}>
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors duration-200">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}